require('./lbLocationSelect.scss');

const $inject = [];

const lbLocationSelect = {
  controller: 'lbLocationSelectCtrl as vm',
  template: require('./lbLocationSelect.html'),
  bindings: {
    name: '@',
    location: '=?',
    airportCode: '=?',
    required: '<',
    disabled: '<',
    placeholder: '<?',
    sct: '<?',
    isPublic: '<?',
  },
};

lbLocationSelect.$inject = $inject;

export default lbLocationSelect;



// WEBPACK FOOTER //
// ./src/components/lbLocationSelect/lbLocationSelect.js